export default __webpack_public_path__ + "static/media/icomoon.02229b8a.eot";